module.exports = __webpack_public_path__ + "994a520d549bfea71485dd1e89d63e7d.svg";